import { LOCIZE_NAMESPACE } from 'main/common'
import * as React from 'react'
import { TFunction, withTranslation } from 'react-i18next'

import { CaretDownIcon } from '../icons'
import {
  Container,
  IconContainer,
  InnerContainer,
  LabelContainer,
  MainLabel,
  StyledSelect,
  UpperLabel,
  ValidationHint,
} from './Select.styles'

const PRE = `MAIN-UI-SELECT`

interface IProps {
  children: React.ReactNode
  label?: string
  validationHint?: string
  value: string | null
  disabled: boolean
  invalid: boolean
  required: boolean
  roundedCorners?: boolean
  onChange: (value: string | null) => void
  t: TFunction
}

interface IState {
  focused: boolean
}

class Select extends React.Component<IProps, IState> {
  public static defaultProps = {
    disabled: false,
    invalid: false,
    required: false,
  }

  public state = {
    focused: false,
  }

  public render() {
    const {
      children,
      disabled,
      invalid,
      label,
      validationHint,
      required,
      value,
      roundedCorners,
      t,
    } = this.props
    const { focused } = this.state

    return (
      <>
        <Container
          disabled={disabled}
          focused={focused}
          invalid={invalid}
          roundedCorners={!!roundedCorners}
        >
          <InnerContainer>
            <LabelContainer>
              {label && (
                <UpperLabel active={this.active} invalid={invalid}>
                  {invalid ? t(`${PRE}-INVALID`) : label}
                </UpperLabel>
              )}

              {label && (
                <MainLabel active={this.active} disabled={disabled} invalid={invalid}>
                  {required ? `${label}*` : label}
                </MainLabel>
              )}
            </LabelContainer>

            <IconContainer disabled={disabled}>
              <CaretDownIcon />
            </IconContainer>
          </InnerContainer>

          <StyledSelect
            active={this.active}
            invalid={invalid}
            hasLabel={!!label}
            value={value === null ? '' : value}
            disabled={disabled}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            required={required}
          >
            {children}
          </StyledSelect>
        </Container>
        {validationHint && <ValidationHint>{validationHint}</ValidationHint>}
      </>
    )
  }

  private handleBlur = () => {
    this.setState({ focused: false })
  }

  private handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target

    this.props.onChange(value === '' ? null : value)
  }

  private handleFocus = () => {
    this.setState({ focused: true })
  }

  get active() {
    return this.props.value !== null
  }
}

export default withTranslation(LOCIZE_NAMESPACE)(Select)
